"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineGroup = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _reactHookForm = require("react-hook-form");

var _lodash = require("lodash");

var _Layout = require("../../../Layout/");

var _Error = _interopRequireDefault(require("../Error"));

var _Hint = _interopRequireDefault(require("../Hint"));

var _context = require("./context");

var _Legend = require("./Legend");

var _Fieldset = require("./Fieldset");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Items = function Items(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'forms.groupItems' : _b,
      inline = _a.inline,
      props = (0, _tslib.__rest)(_a, ["variant", "inline"]);
  return _react.default.createElement(_Layout.Flex, (0, _tslib.__assign)({
    sx: {
      display: 'inline-flex',
      flexDirection: 'row',
      flex: '0 0 auto',
      marginRight: 2,
      variant: "forms." + variant + ".group.inline.items"
    }
  }, props));
};

var InlineGroup = function InlineGroup(_a) {
  var children = _a.children,
      hint = _a.hint,
      label = _a.label,
      name = _a.name;
  var errors = (0, _reactHookForm.useFormContext)().errors;
  return _react.default.createElement(_context.GroupContext.Provider, {
    value: {
      inGroup: true,
      name: name
    }
  }, _react.default.createElement(_Fieldset.Fieldset, {
    as: "fieldset",
    id: name,
    tabIndex: -1
  }, _react.default.createElement(_Layout.Flex, {
    sx: {
      flexDirection: 'row'
    }
  }, _react.default.createElement(_Layout.Box, {
    sx: {
      order: 1
    }
  }, label && _react.default.createElement(_Legend.Legend, null, label), hint && _react.default.createElement(_Hint.default, {
    pb: 1
  }, hint), (0, _lodash.get)(errors, name) && _react.default.createElement(_Error.default, null, (0, _lodash.get)(errors, name))), _react.default.createElement(Items, {
    as: "section",
    hasLabel: !!label
  }, children))));
};

exports.InlineGroup = InlineGroup;